import React, { useEffect } from 'react'
import styles from './index.module.css'
import Modal from 'react-responsive-modal'
import ModalFooter from '../../../../../components/ModalFooter/ModalFooter'
import { Input, Select } from '../../../../../components/ModalInputs'
import { useDispatch, useSelector } from 'react-redux'
import { getStudyPlanList, getStudyTrackProfile } from '../../../../../actions/studyPlans'
import { PARALLELS } from '../../../../../assets/const'
import { addStudyPlanDOCourse, editStudyPlanDOCourse } from '../../../../../actions/studyPlansDO'



const Index = ({ compoundModalOpen, setCompoundModalOpen, closeModal, addMode, xp_tracks, }) => {

    const dispatch = useDispatch()

    const { fullList = [], track_profile = [] } = useSelector(state => state.studyPlans)
    const { extraEduList } = useSelector(state => state.directoryExtraEducation)
    // const { parallels } = useSelector(state => state.common)  .. не те

    useEffect(() => {
        dispatch(getStudyPlanList());
        dispatch(getStudyTrackProfile());
    }, [])

    const renderOptions = ({ name, cid, xp_key, year }) => <option value={xp_key || year} key={xp_key || year}>{name || year}</option>
    const renderOptions_ = ({ trp_id, name }) => <option value={trp_id} key={trp_id}>{name}</option>

    const handleChange = (e) => {
        setCompoundModalOpen({ ...compoundModalOpen, [e.target.name]: Number(e.target.value) })
    }
    const handleSubmit = () => {
        if (addMode) {
            dispatch(addStudyPlanDOCourse({ xp_tracks, ...compoundModalOpen }))
            closeModal()
        } else {
            dispatch(editStudyPlanDOCourse(compoundModalOpen))
            closeModal()
        }
    }

    return (
        <Modal
            open={!!compoundModalOpen}
            onClose={closeModal}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            showCloseIcon={true}
            animationDuration={1}
            classNames={{
                modal: styles.modalMain
            }}
        >

            <div className={styles.modalContent}>
                <h1 className={styles.modalHeader}>{!addMode ? 'Изменить' : 'Создать'}</h1>
                <div className={styles.modalMenu}>
                    <div className={styles.inputsRow}>
                        <Select
                            label='Предмет'
                            name='xp_courses'
                            value={compoundModalOpen?.xp_courses}
                            onChange={e => handleChange({ target: { name: 'xp_courses', value: Number(e.target.value) } })}>
                            {[{ xp_key: '', name: 'Выбрать' }, ...extraEduList]?.map(renderOptions)}
                        </Select>
                    </div>

                    <div className={styles.inputsRow}>
                        <Select
                            label='Паралель'
                            name='level'
                            value={compoundModalOpen?.level}
                            onChange={e => handleChange({ target: { name: 'level', value: Number(e.target.value) } })}>
                            {[{ values: '', name: 'Выбрать' }, ...PARALLELS]?.map(renderOptions)}
                        </Select>
                    </div>

                    <div className={styles.tabWrapper}>
                        <div className={styles.inputsRow}>
                            <Input
                                type='number'
                                label='Часы в год'
                                maxLength={9}
                                onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
                                name='hours'
                                value={compoundModalOpen?.hours}
                                onChange={e => handleChange(e)} />
                        </div>
                        <div className={styles.inputsRow}>
                            <Input
                                type='number'
                                label='Часы в неделю'
                                maxLength={9}
                                onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
                                name='hoursweek'
                                value={compoundModalOpen?.hoursweek}
                                onChange={e => handleChange(e)} />
                        </div>


                    </div>

                </div>
            </div>

            <ModalFooter isShowInfo={true} closeModal={closeModal} handleSubmit={handleSubmit}
            />
        </Modal>
    )
}

export default Index